import { useCallback, useState } from "react";
import {
  getAuth,
  signInWithPopup,
  signInWithEmailAndPassword,
  FacebookAuthProvider,
  GoogleAuthProvider,
} from "firebase/auth";

import { showError } from "infra/helpers/alerta";
import error from "core/resources/firebase/error";
import { useCurrentAuth } from "../auth.store";
import { registerMixpanel } from "infra/packages/mixpanel";
import { trackEvent } from "infra/helpers/event";
import { registerClarity } from "infra/packages/clarity";

const auth = getAuth();

export default function useLogin() {
  const [isLoading, setIsLoading] = useState(false);
  const { updateIsLogged } = useCurrentAuth();

  const handleLogin = useCallback(
    async (provider) => {
      try {
        setIsLoading(true);

        const { user } = await signInWithPopup(auth, provider);

        updateIsLogged();

        registerMixpanel({
          id: user.uid,
          nome: user.displayName!,
          email: user.email!,
        });
        
        registerClarity({
          id: user.uid,
          nome: user.displayName!,
          email: user.email!,
        });

        trackEvent("LoginSocialSucesso", {
          id: user.uid,
          email: user.email,
          provider: user.providerData[0].providerId,
        });
      } catch (err) {
        trackEvent("LoginSocialErro", {
          provider: provider,
          error: error[(err as any).code] ?? error.message ?? null,
        });

        showError(error[(err as any).code]);
        setIsLoading(false);
      }
    },
    [updateIsLogged]
  );

  const handleLoginGoogle = useCallback(async () => {
    return handleLogin(new GoogleAuthProvider());
  }, [handleLogin]);

  const handleLoginFacebook = useCallback(async () => {
    return handleLogin(new FacebookAuthProvider());
  }, [handleLogin]);

  const handleLoginEmail = useCallback(
    async ({ username, password }) => {
      try {
        setIsLoading(true);

        const { user } = await signInWithEmailAndPassword(
          auth,
          username,
          password
        );

        registerMixpanel({
          id: user.uid,
          nome: user.displayName!,
          email: user.email!,
        });

        registerClarity({
          id: user.uid,
          nome: user.displayName!,
          email: user.email!,
        });

        trackEvent("LoginEmailSucesso", {
          id: user.uid,
          email: user.email,
          provider: "email",
        });

        updateIsLogged();
      } catch (err) {
        trackEvent("LoginEmailErro", {
          email: username,
          error: error[(err as any).code] ?? error.message ?? null,
          errorPlain: err,
        });
        showError(error[(err as any).code] ?? "Não foi possível entrar");
        setIsLoading(false);
      }
    },
    [updateIsLogged]
  );

  return {
    handleLoginGoogle,
    handleLoginEmail,
    handleLoginFacebook,
    isLoading,
  };
}
